import { Redirect, Route, useLocation } from 'react-router-dom';
import api from 'api/client';
import React, { useEffect } from 'react';

const CommonRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) => <Component {...props} />}
    />
  );
};

export default CommonRoute;
